module.exports = "<div class=\"filterArea MCS_filter_view\">{{{radio_buttons}}}<div class=\"clear\"></div></div>";